import React from 'react';
import './AlertBanner.css';

const AlertBanner = ({ message, submessage, type = 'warning' }) => {
  return (
    <div className={`alert-banner alert-${type}`}>
      <span className="alert-icon">⚠</span>
      <div className="alert-content">
        <strong>{message}</strong>
        {submessage && <p>{submessage}</p>}
      </div>
    </div>
  );
};

export default AlertBanner;
